import { Box, Heading, Text, SideSheet, useSnackbar, SideSheetProps } from 'pounceV2';
import React from 'react';
import { extractErrorMessage } from 'Helpers/utils';
import UserFormV3 from 'Components/forms/UserForm/UserFormV3';
import { UserRoleInputKind } from 'Generated/schema';
import { useTheme } from '@mui/material';
import { useInviteUser } from './graphql/inviteUser.generated';

const initialValues = {
  email: '',
  familyName: '',
  givenName: '',
  role: null,
};

const UserInvitationSidesheetV3: React.FC<SideSheetProps> = props => {
  const {
    palette: { tokens },
  } = useTheme();
  const { pushSnackbar } = useSnackbar();
  const [inviteUser] = useInviteUser({
    update: (cache, { data }) => {
      cache.modify({
        fields: {
          users(existingData, { toReference }) {
            return [toReference(data.inviteUser.user), ...existingData];
          },
        },
      });
    },
    onCompleted: () => {
      props.onClose();
      pushSnackbar({ variant: 'success', title: 'User invited successfully' });
    },
    onError: error => pushSnackbar({ variant: 'error', title: extractErrorMessage(error) }),
  });

  return (
    <SideSheet
      data-tracking-page="user-invitation"
      aria-labelledby="sidesheet-title"
      aria-describedby="sidesheet-description role-disclaimer"
      {...props}
    >
      <Box width={600} m="auto">
        <Heading variant="h5" fontWeight="bold" mb={9} id="sidesheet-title">
          Invite User
        </Heading>
        <Text
          variant="body/sm"
          color={tokens.content.text.neutral[2]}
          mb={5}
          id="sidesheet-description"
        >
          By inviting users to join your organization, they will receive an email with temporary
          credentials that they can use to sign in to the platform
        </Text>
        <UserFormV3
          initialValues={initialValues}
          onSubmit={({ role, ...rest }) =>
            inviteUser({
              variables: {
                input: {
                  ...rest,
                  role: { kind: UserRoleInputKind.Id, value: role.id },
                },
              },
            })
          }
        />
      </Box>
    </SideSheet>
  );
};

export default UserInvitationSidesheetV3;
